import { FC } from 'react';
import intl from 'react-intl-universal';
import { tailwindOverride, Typography } from '@getsynapse/design-system';
import type { ProjectPriority as ProjectPriorityType } from 'utils/types/projectsList';

interface ProjectPriorityProps {
  priority?: ProjectPriorityType;
  className?: string;
}

const ProjectPriority: FC<ProjectPriorityProps> = ({ priority, className }) => {
  if (!priority) {
    return null;
  }

  return (
    <div className={tailwindOverride('flex items-center', className)}>
      <Typography variant='label'>
        {intl.get(`PROJECT_DETAIL.PRIORITY_OPTIONS.${priority.toUpperCase()}`)}
      </Typography>
    </div>
  );
};

export default ProjectPriority;
